module.exports = __webpack_public_path__ + "80c7e01444d8e03a70b845b876f268b0.pdf";